import { render, staticRenderFns } from "./preformatted-modal.vue?vue&type=template&id=0dc6d85e&scoped=true&"
import script from "./preformatted-modal.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal.scss?vue&type=style&index=0&id=0dc6d85e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6d85e",
  null
  
)

export default component.exports